import { useEffect, useRef, useState, type AudioHTMLAttributes } from 'react';
import {
  attachAudioRecovery,
  consumeDeliveryPause,
  playDeliveredAudio,
  prepareAudioPlayback,
} from '../../lib/audioDelivery';

/** Native share-page controls with the same lease policy as the application player. */
export default function DeliveryAudio(props: AudioHTMLAttributes<HTMLAudioElement>) {
  const ref = useRef<HTMLAudioElement>(null);
  const wantsPlayback = useRef(false);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    const audio = ref.current;
    if (!audio) return;
    wantsPlayback.current = false;
    const cleanup = attachAudioRecovery(
      audio,
      () => wantsPlayback.current,
      () => setFailed(true)
    );
    void prepareAudioPlayback(audio).catch(() => setFailed(true));
    return () => {
      wantsPlayback.current = false;
      cleanup();
    };
  }, [props.src]);
  return (
    <>
      <audio
        {...props}
        ref={ref}
        preload="metadata"
        onPlay={(event) => {
          wantsPlayback.current = true;
          setFailed(false);
          props.onPlay?.(event);
          void playDeliveredAudio(event.currentTarget, () => wantsPlayback.current).catch(() =>
            setFailed(true)
          );
        }}
        onPause={(event) => {
          if (!consumeDeliveryPause(event.currentTarget)) wantsPlayback.current = false;
          props.onPause?.(event);
        }}
        onEnded={(event) => {
          wantsPlayback.current = false;
          props.onEnded?.(event);
        }}
      />
      {failed && <p role="status">Playback unavailable. Please try again.</p>}
    </>
  );
}
